import React, { window } from "react";
import "./protfoliofront.css";
import "bootstrap/dist/css/bootstrap.css";
import hill1 from "./hill1.png";
import hill2 from "./hill2.1.png";
import hill3 from "./hill3.png";
import hill4 from "./hill4.png";
import hill5 from "./hill5.png";
import leag from "./leaf.png";
import plant from "./plant.png";
import tree from "./tree.png";
import "bootstrap/dist/css/bootstrap.css";
import { motion } from "framer-motion";
export function Profront() {
  return (
    <>
      <div className="profrontbody" id="/">
        <div className="profrontimg">
          <img src={hill1} className="hill1" />
          <img src={hill2} className="hill2" />
          <img src={hill3} className="hill3" />
          <img src={hill4} className="hill4" />
          <img src={hill5} className="hill5" />
          <motion.h1
            initial={{ opacity: 0, y: -100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5 }}
            className="text text-center"
          >
            I am{" "}
          </motion.h1>
          <motion.h1
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5 }}
            className="harihome"
          >
            Haridass
          </motion.h1>

          <img src={tree} className="tree" />
          <img src={plant} className="plant" />
          <img src={leag} id="leaf" />
        </div>
      </div>
    </>
  );
}
